import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
import { shimmerAnimation, getShimmerStyles, getColors } from './shared';
const useStyles = createUseStyles(theme => {
  const {
    baseColor,
    shimmerColor,
    lighterShimmerColor
  } = getColors(theme);
  const axisLabelStyles = {
    content: '""',
    position: 'absolute',
    width: '2.5em',
    height: '1em',
    borderRadius: '1em'
  };
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 3em 2em 0'
    },
    row: ({
      padding
    }) => ({
      position: 'relative',
      flexGrow: 1,
      display: 'flex',
      '&+&': {
        paddingTop: `${padding}px`
      },
      '&:nth-child(odd)': {
        '&:before': { ...axisLabelStyles,
          right: 0,
          transform: `translate(3em, 25%)`,
          backgroundColor: baseColor
        },
        '&:after': { ...axisLabelStyles,
          right: 0,
          transform: `translate(3em, 25%)`,
          opacity: 0,
          backgroundColor: lighterShimmerColor,
          animation: '$shimmer 2s infinite'
        }
      },
      '&:last-child': {
        '&>$cell': {
          position: 'relative',
          '&:before': { ...axisLabelStyles,
            left: 0,
            bottom: 0,
            transform: `translate(25%, 1.5em)`,
            backgroundColor: baseColor
          }
        }
      }
    }),
    cell: ({
      padding
    }) => ({
      flexGrow: 1,
      backgroundColor: baseColor,
      ...getShimmerStyles(theme, {
        opacity: 0,
        backgroundColor: shimmerColor,
        animation: '$shimmer 2s infinite'
      }),
      '&+&': {
        marginLeft: `${padding}px`
      }
    }),
    ...shimmerAnimation
  };
});
export const SkeletonHeatMapChart = props => {
  const {
    rows: rowsProp,
    columns: columnsProp,
    paddingInPx = 10,
    classes: classesProp,
    className: classNameProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp, {
    padding: paddingInPx
  });
  const className = clsx(classes.root, classNameProp);
  const rows = Array(rowsProp).fill(null);
  const columns = Array(columnsProp).fill(null);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), rows.map((_row, rowIndex) => {
    const rowKey = `row-${rowIndex}`;
    return /*#__PURE__*/React.createElement("div", {
      key: rowKey,
      className: classes.row
    }, columns.map((_column, columnIndex) => {
      const cellKey = `cell-${columnIndex}`;
      return /*#__PURE__*/React.createElement("span", {
        key: cellKey,
        className: classes.cell
      });
    }));
  }));
};